import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Responsaveis = () => {
  const navigate = useNavigate();
  
  // Redirecionar para o dashboard, pois esta tela não é mais usada
  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  // Retornar null enquanto redireciona
  return null;
};

export default Responsaveis;
